import { formatDate } from "../../../../utils"
import { getCityDisplayName } from "../../../../utils/cities"
import Config from '../../../../config';
const BASE_URL = Config.BASE_URL;


export const WebsiteSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Onsitego",
    "alternateName": "Onsitego | One-Stop Solution for All Your Devices - Protection Plans, Repair & Maintenance Services",
    "url": "https://onsitego.com/",
    "logo": "https://d2js0267gg4oqb.cloudfront.net/_next/static/media/onsite-logo-inverse.8190a3419a1359a4a0b5ff4aa42b6dfe.png",
    "sameAs": [
      "https://facebook.com/onsitego",
      "https://twitter.com/onsitego",
      "https://www.instagram.com/onsitego/",
      "https://www.youtube.com/c/Onsitego_official",
      "https://www.linkedin.com/company/onsitego"
    ],			
      "Review":[
      {	
      "@type": "Review",
          "url": "https://www.business-standard.com/article/technology/laptop-troubles-in-wfh-over-82-are-hardware-related-says-report-121032700765_1.html",
          "author": {
            "@type": "Person",
            "name": "BS Web Team"
          },
          "publisher": {
            "@type": "Organization",
            "name": "BusinessStandard",
            "sameAs": "https://www.business-standard.com/"
          },
          "datePublished": "2021-03-27T18:22",
          "description": "More than 82 percent of troubles with laptops are hardware-related and just 18 percent of them are software related, according to a report by Onsitego",
          "inLanguage": "en"
        },
        {
          "@type": "Review",
          "url": "https://www.moneycontrol.com/news/business/onsitego-sees-rise-in-demand-for-repair-servicing-of-appliances-6264591.html",
          "author": {
            "@type": "Person",
            "name": "M SARASWATHY"
          },
          "publisher": {
            "@type": "Organization",
            "name": "moneycontrol",
            "sameAs": "https://www.moneycontrol.com/"
          },
          "datePublished": "2020-08-23T20:37",
          "description": "Onsitego sees rise in demand for repair, servicing of appliances.",
          "inLanguage": "en"
        }
       ],
      
      "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.9",
          "bestRating": "5",
          "worstRating": "1",
          "ratingCount": "5123"
  }			
  }
                        
  
  export const FaqEntities =  (props) => props.data.faqs.map((item)=>{
    return {
      "@type": "Question",
      "name": item.title,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": item.answer
      }
    }
   }
  )
  
  export const BreadCrumbEntities = (props) => props.data.breadcrumb.map((item, index)=>{
    if(item==='Home')
    {
      return {
        "@type": "ListItem", 
        "position": index+1, 
        "name": item,
        "item": BASE_URL
      }    
    }
    else if(props.data.breadcrumb.length===3 && index===1)
    {
      return {
        "@type": "ListItem", 
        "position": index+1, 
        "name": item,
        "item": BASE_URL + "c?city=" + item
      }
    }
    else{
      return {
        "@type": "ListItem", 
        "position": index+1, 
        "name": item,
        "item": BASE_URL + props.data.slug_mapping?.slug
      }
    }
  })
  
  export const category_type = (props) => Array.from(new Set(props.instaplans.length!==0 ? props.instaplans.map((item)=>{
    return item.category_type
  }):[]));
  
  
  
  export const LocalBusinessEntities = (props) => category_type(props).map((item) => {
    const list = props.instaplans.filter(plan => plan.category_type === item).map((plan) => {
      return {
        "@type": "Offer",
        "price": plan.price ? plan.price.toString() : "",
        "priceCurrency": "INR",
        "itemOffered": {
          "@type": "Service",
          "name": plan.title
        }
      }
    }
    )
    return {
      "@type": "OfferCatalog",
      "name": item,
      "itemListElement": list
    }
  })
  
  export const FaqSchema = (props) =>  {
    return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FaqEntities(props)
    }
  }
  
  export const BreadCrumbSchema  = (props) => {return {
    "@context": "https://schema.org/", 
    "@type": "BreadcrumbList", 
    "itemListElement": BreadCrumbEntities(props)
    }
  }
  
  export const LocalBusinessSchema = (props) => { return {
    "@context": "https://schema.org/",
    "@type": "Service",
    "serviceType": props.data.breadcrumb.length===3 ? props.data.breadcrumb[2] : "",
    "provider": {
      "@type": "LocalBusiness",
      "name": props.data.breadcrumb.length===3 ? props.data.breadcrumb[2] : ""
    },
    "areaServed": props.data.slug_mapping.cities_covered && props.data.slug_mapping.cities_covered.map((item)=>{
      return {
        "@type": "City",
        "name": getCityDisplayName(item.name)
      }
    }),
    "hasOfferCatalog": {
      "@type": "OfferCatalog",
      "name":  props.data.breadcrumb.length===3 ? props.data.breadcrumb[2] : "",
      "itemListElement": LocalBusinessEntities(props)
    }  
    }
  }
  
  export const ProductSchema = (props) => props.instaplans.length!==0 && props.instaplans.map((plan) => {
    return {
    "@context": "https://schema.org/", 
    "@type": "Product", 
    "name": plan.title,
    "image": plan.category_image,
    "description": plan.title_description,
    "brand": props.data.page_meta.popularBrands?.brands && props.data.page_meta.popularBrands?.brands.map((item)=>{
      return {
        "@type": "Brand",
        "name": item
      }
    }),
    "sku": plan.display_title,
    "gtin8": "",
    "offers": {
      "@type": "Offer",
      "priceCurrency": "INR",
      "price": plan.price ? plan.price.toString() : "",
      "availability": "https://schema.org/InStock",
      "itemCondition": "https://schema.org/NewCondition"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "bestRating": "5",
      "worstRating": "1",
      "ratingCount": "9999"
    },  
    "review": props.data.testimonials.map((item)=>{
      return {
        "@type": "Review",
        "name": item.customer_name,
        "reviewBody": item.review,
        "reviewRating": {
          "@type": "Rating",
          "ratingValue": "4",
          "bestRating": "5",
          "worstRating": "1"
        },
        "datePublished": formatDate(new Date()),
        "author": {"@type": "Person", "name": item.customer_name}
      }
    })
    }
  })